import { AxiosError } from "axios";
import {
  QueryFunction,
  QueryKey,
  useQuery,
  useQueryClient,
  UseQueryOptions,
  UseQueryResult,
} from "react-query";
import { refreshAccessTokenRequest } from "../../api/auth.requests";
import { Authority } from "../providers/AuthProvider";
import { useAuth } from "./useAuth";
import { useAxios } from "./useAxios";
import { useIsFetching } from "react-query";
import { useGlobalState } from "./useGlobalState";
import { QUERY_KEYS } from "../../constants/queries";

export const useQueryWithRefresh = <T>(
  queryKey: Key,
  queryFn: (...args: any) => Promise<T>,
  options?: Omit<
    UseQueryOptions<
      T,
      AxiosError,
      T,
      Key
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const retries = 5;

  const axios = useAxios();
  const { auth, setAuth } = useAuth();
  const { setGlobalState } = useGlobalState();
  const queryClient = useQueryClient();
  const isFetchingRefreshToken = useIsFetching([QUERY_KEYS.getRefreshToken]);

  const modifiedQueryKey: Key = [
    ...queryKey,
    auth.accessToken,
    auth.tenantId,
  ];
  // options.queryKey = [options.queryKey, auth.accessToken, auth.tenantId];
  // const queryKey: QueryKey = [options.queryKey, auth.accessToken || "", auth.tenantId || ""];
  const query = useQuery(
    modifiedQueryKey,
    queryFn,
    {
      ...options,
      retry: (failureCount: number, error: unknown) => {
        if (failureCount > retries) {
          return false;
        }

        // if (error.response?.status === 401 || error.response?.status === 500) {
        //   getRefreshAccessTokenRequest({
        //     axios,
        //     refreshToken: auth.refreshToken,
        //     tenantId: auth.tenantId,
        //   }).then((res) => {
        //     // @ts-ignore
        //     const accessToken = `bearer ${res.data.access_token}`;
        //     // @ts-ignore
        //     const authorities = res.data.authorities.map(
        //       (item: any) => item.authority,
        //     ) as Authority[];
        //     setAuth({
        //       // @ts-ignore
        //       accessToken,
        //       authorities,
        //     });
        //   });
        //   queryClient.invalidateQueries(modifiedQueryKey);
        // }
        // @ts-ignore
        if (error.response?.status === 401) {
          setGlobalState({
            hasFetchedRefreshToken: false,
          });
          // console.log("hasFetched to false");
          // console.log(isFetchingRefreshToken);
          queryClient.invalidateQueries([
            QUERY_KEYS.getRefreshToken,
            auth.refreshToken,
          ]);
        }

        return true;
      },
      enabled: (options?.enabled != undefined ? options.enabled : true) &&
        isFetchingRefreshToken === 0,
    },
  );
  return query;
};

// Types
type Key = any[];
